import { lazy, Suspense } from 'react';
import { Navigate, useRoutes, type RouteObject } from 'react-router-dom';

import { Routes } from 'config';
import { useLoggerHook } from 'hooks';
import { Loader } from 'components/loader';

// Eager load layouts (needed immediately)
import RootLayout from './layout';

// Lazy load pages
const HomePage = lazy(() => import('../pages/home'));
const NotFound = lazy(() => import('../pages/not-found'));

export const appRoutes: RouteObject[] = [
  {
    path: Routes.Home,
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: Routes.NotFound,
        element: <NotFound homePath={Routes.Home} />,
      },
      {
        path: '*',
        element: <Navigate replace to={Routes.NotFound} />,
      },
    ],
  },
];

export const AppRoutes = () => {
  const element = useRoutes(appRoutes);

  useLoggerHook();

  return <Suspense fallback={<Loader isLoading />}>{element}</Suspense>;
};
